import { __rest } from "tslib";
import { withWixStyle } from './useWixStyle';
export var themeStrategy = function (_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.useWixStyles, useWixStyles = _b === void 0 ? false : _b, rest = __rest(_a, ["useWixStyles"]);
    return useWixStyles ? withWixStyle(rest) : rest;
};
//# sourceMappingURL=themeStrategy.js.map